export enum AuthRoutes {
  blank = '/',
  dashboard = '/dashboard',
  users = '/users',
  stockists = '/stockists',
  tasks = '/tasks',
  uploadStock = '/upload-stock',
  monthlyStockList = '/list',
  verifyStock = '/verify-stock/:mode/:id',
  profile = '/profile',
  changePassword = '/change-password',
  templates = '/templates',
  productDivisions = '/divisions',
  products = '/products-list',
}

export enum RouteParamsTypes {
  any = '/*',
  id = '/:id',
  blank = '',
  add = '/add',
  edit = '/edit',
  view = '/view',
  list = '/list',
}

export enum Modules {
  auth = '/auth',
  home = '/home',
  resources = '/resources',
  tasks = '/tasks',
  monthlyStock = '/monthly-stock',
  error = '/error',
  my = '/my',
  templates = '/templates',
  products = '/products',
}

export enum NonAuthRoutes {
  login = '/login',
  forbidden = '/forbidden',
  unHandledRejection = '/server-error',
  notFound = '/page-not-found',
  forgotPassword = '/forgot-password',
  resetPassword = '/reset-password',
  tenantInvalid = '/tenant-invalid',
}

export enum PermissionActionsEnum {
  View = 'view',
  Add = 'add',
  Update = 'update',
  Delete = 'delete',
  Email = 'email',
  Export = 'export',
  Import = 'import',
}

export enum PermissionModulesEnum {
  Users = 'users',
  Dashboard = 'dashboard',
  Tasks = 'tasks',
  Stockists = 'stockists',
  Templates = 'templates',
  MonthlyStock = 'monthly_stock',
  ProductDivisions = 'product_divisions',
  Products = 'products',
}

export enum SortOrder {
  asc = 'ASC',
  desc = 'DESC',
}

export enum RowClassName {
  even = 'even',
  odd = 'odd',
}

export enum RoleCodes {
  system_admin = 'system_admin',
  admin = 'admin',
  manager = 'manager',
}
